import React from 'react';
import { Link } from 'react-router';
import { useHoverCard } from 'hooks/useHoverCard';
import UserHoverCard from 'components/UserHoverCard/UserHoverCard';
import EliteBadge from 'components/EliteBadge/EliteBadge';
import './UsernameLink.css';

interface UsernameLinkProps {
  username: string;
  isElite?: boolean;
  showHoverCard?: boolean;
  className?: string;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  as?: 'link' | 'span';
}

const UsernameLink: React.FC<UsernameLinkProps> = ({
  username,
  isElite,
  showHoverCard = true,
  className,
  children,
  onClick,
  as = 'link',
}) => {
  const { triggerProps, cardProps, isVisible, position, data, isLoading } =
    useHoverCard(username, showHoverCard);

  const hoverCard = isVisible ? (
    <UserHoverCard
      data={data}
      isLoading={isLoading}
      position={position}
      cardProps={cardProps}
    />
  ) : null;

  if (as === 'span') {
    return (
      <>
        <span
          className={`username-link--span ${className || ''}`}
          onClick={onClick}
          {...triggerProps}
        >
          {children || username}
          <EliteBadge isElite={!!isElite} />
        </span>
        {hoverCard}
      </>
    );
  }

  return (
    <>
      <Link
        to={`/profile/u/${encodeURIComponent(username)}`}
        className={`username-link ${className || ''}`}
        onClick={onClick}
        {...triggerProps}
      >
        {children || username}
        <EliteBadge isElite={!!isElite} />
      </Link>
      {hoverCard}
    </>
  );
};

export default UsernameLink;
